const styleSheet = () => ({
  button: {
    border: 0,
  },
  select: {
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 300,
    border: 'none',
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'relative',
    cursor: 'pointer',
    width: '100%',
    fontSize: '14px',
    color: '#085FE5',
    padding: '10px 12px',
    paddingTop: 0,
    backgroundColor: 'transparent',
    appearance: 'none',
    '& .icon': {
      top: '9px',
      width: '16px',
      position: 'relative',
      transformOrigin: '50% 50%',
      marginLeft: '10px',
    },
  },
  wrapper: {
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 300,
    top: (props: any) => props.top,
    position: 'relative',
    float: 'right',
    display: 'inline-block',
  },
  optionsHolder: {
    position: 'absolute',
    width: (props: any) => props.width,
    right: 0,
    zIndex: 2,
    marginTop: '13px',
  },
  dropDown: {
    padding: '12px 12px',
    zIndex: 2,
    width: '100%',
    borderRadius: '4px',
    backgroundColor: '#223762',
    boxShadow: '0 2px 6px 0 rgba(0,0,0,0.2)',
  },
  dropDownItem: {
    cursor: 'pointer',
    padding: '10px 12px',
    fontSize: '14px',
    textAlign: 'left',
    color: '#ffffff',
  },
  moreIcon: {
    '& circle': {
      fill: '#085FE5',
    },
  },
});

export default styleSheet;
